const email = (value: string): string | undefined =>
  value && !/\S+@\S+\.\S+/.test(value) ? 'Must be a valid email address.' : undefined;

export default email;
